import { AccountIconSet, accountIconNames } from '@estee/elc-icons';
import { events } from '@estee/elc-service-bus';

interface IMenuIcon {
    className: string;
    eventToEmit: string | null;
    icon: React.ElementType | null;
    iconName?: string;
    translation?: string;
}

interface IMenuIcons {
    [key: string]: IMenuIcon;
}

export const menuLinkMappings: IMenuIcons = {
    sidebarAccount: {
        icon: AccountIconSet,
        iconName: accountIconNames.userCircle,
        className: 'icon-account',
        eventToEmit: null
    },
    sidebarOrders: {
        icon: AccountIconSet,
        iconName: accountIconNames.packageClosed,
        className: 'icon-orders',
        eventToEmit: null
    },
    sidebarReorders: {
        icon: AccountIconSet,
        iconName: accountIconNames.handbag,
        className: 'icon-orders',
        eventToEmit: null
    },
    sidebarShippingAndBilling: {
        icon: AccountIconSet,
        iconName: accountIconNames.truck,
        className: 'icon-addressbook',
        eventToEmit: null
    },
    sidebarSubscriptions: {
        icon: AccountIconSet,
        iconName: accountIconNames.clock,
        className: 'icon-subscriptions',
        eventToEmit: null
    },
    sidebarConsultations: {
        icon: AccountIconSet,
        iconName: accountIconNames.cardlist,
        className: 'icon-consultations',
        eventToEmit: null
    },
    sidebarLiveChat: {
        icon: AccountIconSet,
        iconName: accountIconNames.chat,
        className: 'icon-livechat',
        eventToEmit: null
    },
    sidebarRewards: {
        icon: AccountIconSet,
        iconName: accountIconNames.trophy,
        className: 'icon-rewards',
        eventToEmit: null
    },
    sidebarReferAFriend: {
        icon: AccountIconSet,
        iconName: accountIconNames.referFriend,
        className: 'icon-refer-friend',
        eventToEmit: null
    },
    sidebarSettings: {
        icon: AccountIconSet,
        iconName: accountIconNames.gear,
        className: 'icon-settings',
        eventToEmit: events.ACCOUNT_SETTINGS_LINK_CLICK
    },
    sidebarSignOut: {
        icon: AccountIconSet,
        iconName: accountIconNames.exit,
        className: 'icon-signout',
        eventToEmit: events.SIGNED_OUT
    }
};
